export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SG-cfb144e2ebb009497a216b77e27ee600.png";